import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import {
  ArticleGroupAiImagesQuery,
  ArticleGroupAiImagesQueryVariables
} from './__generated__/ArticleGroupAiImagesQuery';

export const ARTICLE_GROUP_AI_IMAGES_QUERY = gql`
  query ArticleGroupAiImagesQuery($id: ID!) {
    articleGroup(id: $id) {
      aiImages {
        id
        url
        styleType
        metrics {
          spent
          ctr
        }
      }
    }
  }
`;

export const useArticleGroupAiImagesLazyQuery = (variables: ArticleGroupAiImagesQueryVariables) => {
  return useLazyQuery<ArticleGroupAiImagesQuery, ArticleGroupAiImagesQueryVariables>(ARTICLE_GROUP_AI_IMAGES_QUERY, {
    client: kmsClient,
    variables,
    fetchPolicy: 'no-cache'
  });
};
